import React from 'react';
import { motion } from 'framer-motion';
import { CedarTreeIcon } from './icons/CedarTreeIcon';
export function HeroSection() {
  return <section id="home" className="relative pt-20 min-h-[85vh] flex items-center justify-center bg-gradient-to-br from-emerald-950 via-emerald-900 to-emerald-800 overflow-hidden" data-id="element-187">
      {/* CSS Geometric Pattern Overlay */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
    }} data-id="element-188"></div>

      {/* Background Watermark */}
      <motion.div className="absolute inset-0 flex items-center justify-center opacity-[0.06] pointer-events-none" initial={{
      scale: 0.8,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 0.06
    }} transition={{
      duration: 2,
      ease: 'easeOut'
    }} data-id="element-189">
        <CedarTreeIcon className="w-[800px] h-[800px] text-white" data-id="element-190" />
      </motion.div>

      <div className="container mx-auto px-4 relative z-10 text-center flex flex-col items-center justify-center h-full py-20" data-id="element-191">
        <div className="max-w-4xl mx-auto space-y-10" data-id="element-192">
          {/* Cedar Icon */}
          <motion.div className="flex justify-center mb-8" initial={{
          opacity: 0,
          scale: 0.5
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-193">
            <div className="relative" data-id="element-194">
              <div className="absolute inset-0 bg-emerald-400 blur-3xl opacity-20 rounded-full" data-id="element-195"></div>
              <CedarTreeIcon className="w-28 h-28 text-white relative z-10 drop-shadow-2xl" data-id="element-196" />
            </div>
          </motion.div>

          {/* Heading */}
          <motion.div className="space-y-6" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: 'easeOut'
        }} data-id="element-197">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-white leading-tight drop-shadow-lg" data-id="element-198">
              Consulate General of Lebanon
            </h1>

            <motion.p className="text-xl md:text-2xl text-emerald-50/90 font-light max-w-3xl mx-auto drop-shadow-md tracking-wide" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.5,
            ease: 'easeOut'
          }} data-id="element-199">
              Serving the Lebanese Community in New South Wales, Australia
            </motion.p>
          </motion.div>

          {/* Buttons */}
          <motion.div className="flex flex-col sm:flex-row items-center justify-center gap-6 pt-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.7,
          ease: 'easeOut'
        }} data-id="element-200">
            <a href="#services" className="w-full sm:w-auto px-10 py-4 bg-white text-emerald-950 font-bold rounded-lg shadow-xl hover:bg-emerald-50 hover:scale-105 transition-all duration-300 text-center text-lg" data-id="element-201">
              Our Services
            </a>
            <a href="#about" className="w-full sm:w-auto px-10 py-4 border-2 border-white/80 text-white font-bold rounded-lg hover:bg-white/10 hover:border-white transition-all duration-300 text-center text-lg backdrop-blur-sm" data-id="element-202">
              Contact Us
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}